const url = '/credit-company-types';
const Provider = 'CreditCompanyTypes';
const dbModel = 'CreditCompanyTypes';

export { url, Provider, dbModel };
